<template>
  <header>
    <div class="header-content" flex flex-center>
      <div id="marca-container" flex flex-center gapped>
        <img id="logo" src="/images/DigitalPower.png" alt="Logo Digital Power" noselect nopointer>
        <h2 id="marca">DIGITAL POWER</h2>
      </div>
      <nav class="desktop-nav">
        <a href="#hero">Inicio</a>
        <a href="#servicios">Servicios</a>
        <a href="#planes">Planes</a>
        <a href="#clientes">Proyectos</a>
        <a href="#dudas" class="btn-primary">Contacto</a>
      </nav>
    </div>
  </header>
  <div id="content">
    <router-view/>
  </div>
</template>

<style lang="scss">
:root {
  --header-height: 80px;
}

body {
  background: var(--bg-color);
  margin: 0;
  padding: 0;
}

header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--header-height);
  z-index: 1000;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0,0,0,0.05);
  transition: all var(--duration);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  padding: 0 2rem;
  justify-content: space-between !important;
}

#marca-container {
  gap: 15px;
}

#logo {
  height: 40px;
  width: auto;
  transition: transform var(--duration);
}

#logo:hover {
  transform: scale(1.05);
}

#marca {
  font-size: 1.4rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.5px;
  margin: 0 !important;
}

.desktop-nav {
  display: flex;
  gap: 2rem;
  align-items: center;

  a {
    text-decoration: none;
    color: var(--text-muted);
    font-weight: 500;
    font-size: 0.95rem;
    transition: color var(--duration);

    &:hover {
      color: var(--primary);
    }
  }

  .btn-primary {
    background: var(--primary);
    color: white !important;
    padding: 0.6rem 1.4rem;
    border-radius: 50px;
    font-weight: 600;
    transition: all var(--duration);
    box-shadow: 0 4px 14px var(--primary-glow);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(79, 70, 229, 0.6);
      background: var(--secondary);
    }
  }
}

#content {
  width: 100%;
  padding-top: var(--header-height);
}

.oCard > p {
  width: 90% !important;
  text-align: center;
  color: white !important;
  font-family: 'Outfit', sans-serif;
  font-weight: 500;
}

@media screen and (max-width: 900px) {
  .desktop-nav {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  #logo {
    height: 32px;
  }
  #marca {
    font-size: 1.1rem;
  }
  .header-content {
    padding: 0 1rem;
  }
}
</style>
<script setup lang="ts">
</script>